import messages_mx from './translations/es-MX.json';
import messages_es from './translations/en-MX.json';

/// Messages
export const messages = {
  'es-MX': messages_mx,
  'en-MX': messages_es
};

/// GRAPHOS
export const PATH_GRAPHO = {
  DEVELOP:    '',
  QA:         'l',
  PRODUCCION: '',
};

export const APIKEY_GRAPGQL = {
  DEVELOP:    '',
  QA:         '',
  PRODUCCION: '',
};

export const CAT_STATUS_CLIENT_RESICO = {
  'Disponible': 'text-tesorero'
}

export const STATUS_CATALOG = {
  1: "Activo",
  2: "Inactivo"
}

export const ERROR_STATUS = {
  503  : "server_unavailable",
  500  : "error_server",
  2136 : "error_network",
  400  : "error_badrequest",
  404  : "error_notFound",
  409  : "error_conflict",
  403  : "forbidden"
};

export const ERROR_CAT_REFERENCES = {
  "bad"           : "No se pudo generar referencia, porfavor comunicarse",
  "withGestorId"  : "Asigna el grupo para generar referencia"
};

export const ICONS_CARD = {
  'collection'                    : 'receipt',
  'detailCollection'              : 'receipt',
  'detailIntegrant'               : 'people',
  'detailAgreement'               : 'receipt',
  'contractCompliance'            : '',
  'contractAuthorizationCredit'   : '',
  'contractPrivacyNotice'         : '',
  'contractMarketingAuthorization': ''
};

export const COLOR_INTEGRANTS = {
  'Presidente' : 'text-blue-500',
  'Secretario' : 'text-indigo-800',
  'Tesorero'   : 'text-green-700',
  'Integrante' : 'text-orange-500'
};

export const CAT_COLLECTION = {
  "collection"                    : "wallet",
  "detailCollection"              : "wallet",
  "detailIntegrant"               : "integrants",
  "detailAgreement"               : "agreement",
  "contractCompliance"            : "",
  "contractAuthorizationCredit"   : "",
  "contractPrivacyNotice"         : "",
  "contractMarketingAuthorization": "",
  "documentAgreement"             : "documentsA"
  
};

export const CAT_VIEWSELECT = {
  "collection"                    : "walletSelected",
  "detailCollection"              : "walletSelected",
  "detailIntegrant"               : "integrantSelected",
  "detailAgreement"               : "agreementSelected",
  "contractCompliance"            : "",
  "contractAuthorizationCredit"   : "",
  "contractPrivacyNotice"         : "",
  "contractMarketingAuthorization": "",
  "documentAgreement"             : ""
};

export const CAT_VIEWBACK = {
  "collection"                    : "collection",
  "detailCollection"              : "collection",
  "detailIntegrant"               : "detailCollection",
  "detailAgreement"               : "collection",
  "contractCompliance"            : "detailIntegrant",
  "contractAuthorizationCredit"   : "detailIntegrant",
  "contractPrivacyNotice"         : "detailIntegrant",
  "contractMarketingAuthorization": "detailIntegrant",
  "documentAgreement"             : "detailAgreement",
  "createEvent"                   : "events"
};

export const CAT_DOCUMENTS_VERIFICATION = {
  'Domicilio Exterior'   : 'exteriorAdress',
  'Domicilio Interior'   : 'interiorAdress',
  'Domicilio referencia' : 'referenceAdress',
  'Domicilio Extra'      : 'extraAdress',
  'Domicilio Extra 2'    : 'albumAdress',
  'Negocio Exterior'     : 'exteriorBusiness',
  'Negocio Interior'     : 'interiorBusiness',
  'Negocio Inventario'   : 'inventoryBunisess',
  'Negocio referencia'   : 'referenceBusiness',
  'Negocio Extra'        : 'extraBusiness',
  'Negocio Extra 2'      : 'extra2Business',
  'Negocio Extra 3'      : 'extra3Business',
  'Negocio Extra 4'      : 'extra4Business',
  'Negocio Extra 5'      : 'extra5Business',
  'Negocio Extra 6'      : 'extra6Business'
}

export const TYPE_AGREEMENTS = {
  0: "Individual",
  1: "Grupal",
}

export const ICON_STATUS = {
  1: 'pi-check',          // Pagado
  2: 'pi-clock',       // pendiente
  3: 'pi-exclamation-triangle',  // parcial
  4: 'pi-times'           // en atraso
};

export const CAT_STATUS_AGREEMENTS = {
  1: "Al corriente",
  2: "En atraso",
  3: "Liquidado"
};


export const CATCOLORS_STATUS_AGREEMENTS = {
  1: "bg-guanajuato",
  2: "bg-irapuato",
  3: "bg-bajioSim"
};

export const PALETA_STATUS_COLORS = {
  1: "var(--succesSIM)",
  2: "var(--colorPresident)",
  3: "var(--colorIntegrant)",
  4: "var(--redSIMStrong)"
};

export const ICON_COLORS = {
  1: "success",     // pagado
  2: "info",       // pendiente
  3: "warning", // parcial
  4: "danger"        // en atraso
};


export const ICON_COLORS_AGREE = {
  1: "#999999",     // pagado
  2: "#999999",     // pendiente
  3: "#292E75",     // parcial
  4: "#999999"      // en atraso
};

export const PROPIETIES_AGREE = {
  1: "",                // pagado
  2: "",                // pendiente
  3: "cursor-pointer",  // parcial
  4: ""                 // en atraso
};

export const CAT_IMAGES = {
  9:  "curp",
  7:  "IFEfront",
  8:  "IFEBack",
  10: "adress"
};

export const CAT_CREDITS = {
  'R': 'Renovación',
  'N': 'Nuevo'
};

export const CATALOG_ERRORS = {
  'requiredAmount'       : true,
  'higher'               : true,
  'requiredMethod'       : true,
  'requiredIntegrant'    : true,
  'requiredProcess'      : true,
  'requiredCard'         : true,
  'requiredDate'         : true,
  'requiredComment'      : true,
  'requiredManager'      : true,
  'requiredDestinity'    : true,
  'requiredMembers'      : true,
  'requiredClient'       : true
};

export const CATALOG_ERRORS_MESSAGE = {
  'requiredAmount'       : "Ingresa monto mayor a 0",
  'higher'               : "El monto no puede ser mayor al pago semanal",
  'requiredMethod'       : "Selecciona método de pago",
  'requiredIntegrant'    : "Selecciona un integrante",
  'requiredProcess'      : "Por favor ingresa un Id proceso",
  'requiredCard'         : "Porfavor ingresa un número de tarjeta",
  'requiredDate'         : "Por favor selecciona una fecha",
  'requiredComment'      : "Por favor ingresa un motivo",
  'requiredManager'      : "Selecciona gestor",
  'requiredDestinity'    : "Selecciona destinatario",
  'requiredMembers'      : "Selecciona clienta",
  'requiredClient'       : "Selecciona clienta",
};

export const IDS_MANAGER_EXTERNOS = {
  2984: '',
  2997: '',
  2998: '',
  2999: '',
  3000: '',
  3002: '',
  3241: '',
  3242: '',
  3493: '',
  4004: '',
  4105: '',
  4108: '',
  4109: '',
  4116: '',
  4117: '',
  4118: '',
  4119: '',
  4120: '',
  4122: '',
  4146: '',
  4148: '',
  4150: '',
  4151: '',
  4152: '',
  4204: '',
  4206: '',
  4209: '',
  4216: '',
  4225: '',
  4289: '',
  4290: '',
  4293: '',
  4402: '',
  4419: '',
  4433: '',
  4434: '',
  4451: '',
  4458: '',
  4546: '',
  4547: '',
  4644: '',
  4703: ''
};

export const COLOR_EVENTS = {
  1: "bg-tesorero text-tesorero",
  6: "bg-colorPrimary text-colorPrimary",
  7: "bg-label text-label"
};

export const COLOR_STYLES_EVENTS = {
  1: "background-color: #026D63; color: #026D63;",
  6: "background-color: #323363; color: #323363;",
  7: "background-color: #CC363E; color: #CC363E;"
};

export const BUNISSESKEY_EVENT = {
  1: "Reunión Informativa",
  2: "Capacitación",
  3: "Promoción",
  4: "Alta de prospecto",
  5: "Detalle de Información",
  6: "Verificación Domicilio",
  7: "Verificación Negocio",
  8: "Reunión Entrega de Crédito",
  9: "Entrega de crédito",
  10: "Reunión 1:1",
  11: "Envío de referencia",
  12: "Entrega tarjeta",
  13: "Cobranza",
  14: "Capacitacion",
  15: "Promocion",
  16: "Asistencia",
};

export const MARKER_STATUS_EVENET = {
  'Pendiente': "icon-clock.svg",
  'Completado': "icon-check.svg",
  'No asistió': "icon-tach.svg",
  'En proceso': "icon-clock.svg",
  'Reagendado': "icon-clock.svg",
  4: "icon-locationGroup.svg",
  5: "icon-locationPerson.svg",
  6: "icon-locationoPersonInactive.svg"
};

export const ICONS_MARKER_BRANCHS = {
  "aguascalientes"        : "Pink.png",
  "celaya"                : "Red.png",
  "guadalajara"           : "Green.png",
  "jilotepec"             : "Gray.png",
  "metepec"               : "Cian.png",
  "merida"                : "Purple.png",
  "queretaro"             : "Coffe.png",
  "sanluispotosi"         : "Blue.png",
  "tepejidelrio"          : "Orange.png",
  "tizimin"               : "Violet.png",
  "valladolid"            : "White.png",
  "zinacantepec"          : "Pink.png",
  "campeche"              : "Red.png",
  "ciudadguzman"          : "Green.png",
  "guanajuato"            : "Gray.png",
  "lapiedad"              : "Cian.png",
  "morelia"               : "Purple.png",
  "pachuca"               : "Orange.png",
  "salamanca"             : "Violet.png",
  "sanmigueldeallende"    : "White.png",
  "tequisquiapan"         : "Pink.png",
  "toluca"                : "Red.png",
  "zacatecas"             : "Green.png",
  "cancun"                : "Gray.png",
  "cozumel"               : "Cian.png",
  "irapuato"              : "Purple.png",
  "leon"                  : "Orange.png",
  "puertovallarta"        : "Violet.png",
  "sanjuandelrio"         : "White.png",
  "santiagotianguistenco" : "Pink.png",
  "ticul"                 : "Red.png",
  "tulancingo"            : "Green.png",
  "zapopan"               : "Gray.png",
  "motul"                 : "Cian.png",
  "valledetoluca"         : "Purple.png",
  "fresnillo"             : "Green.png",
  "corporativo"           : "Gray.png",
  "playadelcarmen"        : "Cian.pn"
};

export const branchImages = {
  Pink: require('../src/assets/img/sucPink.png'),
  Red: require('../src/assets/img/sucRed.png'),
  Green: require('../src/assets/img/sucGreen.png'),
  Gray: require('../src/assets/img/sucGray.png'),
  Cian: require('../src/assets/img/sucCian.png'),
  Purple: require('../src/assets/img/sucPurple.png'),
  Coffe: require('../src/assets/img/sucCoffe.png'),
  Blue: require('../src/assets/img/sucBlue.png'),
  Orange: require('../src/assets/img/sucOrange.png'),
  Violet: require('../src/assets/img/sucViolet.png'),
  White: require('../src/assets/img/sucWhite.png'),
};

export const CAT_DELAY_DAYS = {
  "wallet"    : "daysDelay",
  "agreement" : "daysDelayTwo"
};

export const CAT_ID_RANGE_DAYS = {
  "1-30":      1,
  "31-60":     2,
  "61-90":     3,
  "91-180":    4,
  "181-270":   5,
  "271-10000": 6,
};

export const  CAT_TYPE_DISPATCH = {
  119 : 5,
  23  : 5,
  147 : 5,
  33  : 1,
  22  : 1, // Gestores
  157 : 3, // Extra Judicial
  156 : 4, // Judicial
  125 : 5, // Lider Regional
  155 : 6, // Gerente de cartera,
  161 : 8,
  8:    8,
  164:  2 // Director de cobranza
};

export const CAT_ID_LEVEL_MAP = {
  0: "region",
  1: "banchOffice",
  2: "managers",
  3: "allbranchs"
};

export const CAT_ID_LEVEL_TOTAL_MAPS = {
  0: "nacional",
  1: "regional",
  2: "regionalSelected",
  3: "branchSelected",
  4: "employeSelected"
};

export const CAT_SUBTIME_COBRANZA = {
};

export const COORDINATES_REGIONALS = {
  2: {lat: -102.7748, long: 21.6878},
  3: {lat: -100.9541, long: 24.5318},
  8: {lat: -90.442,   long: 20.7139},
  6: {lat: -100.3724, long: 20.2294},
  7: {lat: -99.0424,  long: 21.2936},
  1: {lat: -99.7816,  long: 21.5148},
  4: {lat: -93.8739,  long: 17.1516}, 
  5: {lat: -102.7525, long: 21.5361},
  9:  {lat: -100.5685, long: 21.5356},
  16: {lat: -87.9797, long: 21.5665},
  12: {lat: -102.4554, long: 21.6627},
  14: {lat: -99.2704, long: 21.5569},
  10: {lat: -94.7758, long: 17.2038}, 
  11: {lat: -102.7907, long: 21.2675},
  15: {lat: -90.4633, long: 20.5893},
  13: {lat: -98.7193, long: 21.2322},
  17: {lat: -99.7816,  long: 21.5148},
  18: {lat: -102.7748, long: 21.6878},
};

export const ENUMS_FILTERS_COLLECTIONS = {
  "directionSelected" : 6,
  "branchSelected"    : 7,
  "managerSelected"   : 8
};

export const ENUM_STATE_COLLECTION_DETAIL = {
  "directionSelected" : "detailDataDirection",
  "branchSelected"    :  "detailDataBranch",
  "managerSelected"   :  "detailManager"
};

export const STYLE_STATUS_AGREEMENTS = {
  1: 'border-2 border-celaya',
  2: 'border-2 border- ',
  3: 'border-2 border-queretaro',
  4: 'border-2 border-colorFF8',
  5: 'border-2 border-',
  6: 'border-2 border-',
  7: 'border-2 border-',
  8: 'border-2 border-',
  9: 'border-2 border-',
  10: 'border-2 border-',
};

export const CAT_BRANCHOFFICE           = `${process.env.REACT_APP_URL_LOWCOLLABORATOR}obtain/branchOffices`;
export const CAT_BRANCHBY_EMPLOYE       = `${process.env.REACT_APP_URL_COBRANZA}branchOffice`;
export const CAT_VISITS                 = `${process.env.REACT_APP_URL_COBRANZA}getvisits`;
export const CAT_ACCUNTSTATUS           = `${process.env.REACT_APP_URL_COBRANZA}getAccountStatus`;
export const CAT_AGREEMENTS             = `${process.env.REACT_APP_URL_COBRANZA}getAgreements`;
export const CAT_AGREE                  = `${process.env.REACT_APP_URL_COBRANZA}agreements`;
export const INTEGRANTS_AGREEMENTS      = `${process.env.REACT_APP_URL_COBRANZA}getAgreementGrupal`;
export const DOCUMENT_AGREEMENTS        = `${process.env.REACT_APP_URL_COBRANZA}integrantsAgreement`;
export const CAT_DOCUMENTS              = `${process.env.REACT_APP_URL_COBRANZA}getDocument`;
export const DETAIL_AGREEMENTS          = `${process.env.REACT_APP_URL_COBRANZA}payment-agreement`;
export const CAT_MANAGERS               = `${process.env.REACT_APP_URL_COBRANZA}collectionAgents`;
export const COLLECTION_GROUPS          = `${process.env.REACT_APP_URL_COBRANZA}groupsCollectionPortfolio`;
export const AMORTIZATIONS              = `${process.env.REACT_APP_URL_COBRANZA}amortizations`;
export const AMORTIZATION_PAYMENTS      = `${process.env.REACT_APP_URL_COBRANZA}portfolio`;
export const ASSIGN_MANAGER             = `${process.env.REACT_APP_URL_COBRANZA}assignCollectionAgent`;
export const REFERENCE_PAYMENT          = `${process.env.REACT_APP_URL_COBRANZA}payment-agreement`;
export const GENERAL_INFORMATION        = `${process.env.REACT_APP_URL_COBRANZA}getGeneralInformationClient`;
export const ADRESS_INFORMATION         = `${process.env.REACT_APP_URL_COBRANZA}getAddressInformationClient`;
export const BUNISESS_INFORMATION       = `${process.env.REACT_APP_URL_COBRANZA}getBusinessInformationClient`;
export const SPOUSE_INFORMATION         = `${process.env.REACT_APP_URL_COBRANZA}getSpouseInformationClient`;
export const REFERENCES_INFORMATION     = `${process.env.REACT_APP_URL_COBRANZA}getReferencesClient`;
export const DATA_CREDIT                = `${process.env.REACT_APP_URL_COBRANZA}getCreditData`;
export const DATA_METAMEMBERSHIP        = `${process.env.REACT_APP_URL_COBRANZA}getDataMetamembresia`;
export const TRANSACTION_CLIENT         = `${process.env.REACT_APP_URL_COBRANZA}getExpectedTransactionalityClient`;
export const PORTFOLIO                  = `${process.env.REACT_APP_URL_COBRANZA}portfolio`;
export const GET_ADRESS_VERIFICATION    = `${process.env.REACT_APP_URL_COBRANZA}getBusinessAddressVerify`;
export const GET_BUSINESS_VERIFICATION  = `${process.env.REACT_APP_URL_COBRANZA}getbusinessVerify`;
export const GET_DOCUMENTS_VERIFICATION = `${process.env.REACT_APP_URL_COBRANZA}getDocumentVerification`;
export const DESENCRIPT_DOCUMENTS       = `${process.env.REACT_APP_URL_COBRANZA}getImageVerification`;
export const GENERATE_REFERENCE_PARTIAL = `${process.env.REACT_APP_URL_API_SIM}generateReferenceParcial/`;